import clsx from 'clsx';

import { formatToMonetary } from 'utils/curo-helpers/formatters';

import styles from './DMBranchOffer.module.scss';

const OPTIONS = [
  'Driver’s license or government-issued ID',
  'Recent proof of income',
  'Proof of residence (current utilities or mortgage/rent bill)',
  'Vehicle Title (only required for vehicle secured loans)',
];

const FOOTER_TEXT =
  'You must continue to meet eligibility requirements at the time of application. Personal property collateral may be requested. Applicants enrolled with a debt settlement agency or consumer credit counseling service are ineligible for this offer. Subject to state regulations, eligibility, credit check, underwriting and approval. Rates, terms and conditions apply.';

interface IBranchInstructions {
  offerAmount: string;
}

const BranchInstructions = ({ offerAmount }: IBranchInstructions) => (
  <div className={styles.container}>
    <p className={styles.subTitle}>
      <p>
        You’re pre-approved for a personal loan up to{' '}
        <span className={styles.subTitleGreen}>{formatToMonetary(Number(offerAmount))}*</span>.
      </p>
      <p> Plus, you may qualify for a higher loan amount with our vehicle secured loan.</p>
    </p>
    <p className={styles.text}>
      Our friendly loan experts will call to discuss your loan options and answer any questions.
    </p>
    <p className={styles.text}>
      You may also call or visit your local branch to continue the application process.
    </p>

    <div className={styles.text}>
      To prepare for the next steps, please have the following information ready:
    </div>

    <div className={styles.optionsWrapper}>
      {OPTIONS.map((option, i) => (
        <div key={i} className={styles.text}>
          <div className={styles.styledCircle} />
          <span>{option}</span>
        </div>
      ))}
    </div>

    <p className={clsx(styles.text)}>
      Once your application is approved, you can receive your funds as soon as the next day!
    </p>

    <div className={styles.textWrapper}>
      <div className={styles.smallText}>*</div>
      <p className={styles.smallText}>{FOOTER_TEXT}</p>
    </div>
  </div>
);

export default BranchInstructions;
